<div class="ap-floating-content-modal">
    <div class="ap-floating-content-modal__header">
        <div class="ap-floating-content-modal__avatar" data-testid="fab-avatar">
            <ap-illustration name="avatar-bot" size="medium"></ap-illustration>
        </div>
        <h1 data-testid="fab-title" class="ap-floating-content-modal__title">{{ title() }}</h1>
        <button
            #minimizeButton
            class="ap-floating-content-modal__back-button"
            (click)="closeEvent.emit(undefined)"
            data-testid="fab-minimize-button"
        >
            <span class="ap-sr-only">{{ 'floatingContentModal.minimize' | apContent }}</span>
            <ap-icon name="minimize" size="medium" data-testid="fab-minimize-icon"></ap-icon>
        </button>
    </div>
    <div
        class="ap-floating-content-modal__container ap-flex ap-flex-column ap-flex-1"
        data-testid="fab-modal-content"
        (transitionend)="contentTransitionEnd($event)"
    >
        <ng-content></ng-content>
    </div>
</div>
